import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import StatsWidget from "@rio-cloud/rio-uikit/StatsWidget";
import StatsWidgetNumber from "@rio-cloud/rio-uikit/StatsWidgetNumber";
import StatsWidgetSpacer from "@rio-cloud/rio-uikit/StatsWidgetSpacer";

import { fetchVolksTotalAssets } from "../../api/fetchBigNumbers";
import { IAssetSummary } from "../../api/fetchMaintenance";

import { Asset } from "../../models/asset";

const VolksTotalPlanBigNumbers = (
    { 
        allAssets,
        assets, 
        assetIds, 
        setAssetIds, 
        filter, 
        setFilter, 
        disabled, 
        bigTableLoading 
    }: 
    { 
        allAssets: Asset[],
        assets: IAssetSummary[], 
        assetIds: string[], 
        setAssetIds: (e: string[] | undefined) => void, 
        filter: string, 
        setFilter: (e: string) => void, 
        disabled?: boolean, 
        bigTableLoading?: boolean 
    }
) => {
    const intl = useIntl();
    const [dataLoaded, setDataLoaded] = useState<boolean>(false)

    const [withVolksTotalPlanLoading, setWithVolksTotalPlanLoading] = useState<boolean>(true);
    const [withVolksTotalPlanAssetIds, setWithVolksTotalPlanAssetIds] = useState<string[]>([]);

    const [withoutVolksTotalPlanLoading, setWithoutVolksTotalPlanLoading] = useState<boolean>(true);
    const [withoutVolksTotalPlanAssetIds, setWithoutVolksTotalPlanAssetIds] = useState<string[]>([]);

    const [assetIdsWithoutFilter, setAssetIdsWithoutFilter] = useState<string[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const fetchWithVolksTotalPlanPromise = fetchVolksTotalAssets(assets);

            fetchWithVolksTotalPlanPromise.then(([, volksTotalAssetIds, withoutVolksTotalAssetIds]) => {
                setWithVolksTotalPlanAssetIds(volksTotalAssetIds);
                setWithoutVolksTotalPlanAssetIds(withoutVolksTotalAssetIds);

                setWithVolksTotalPlanLoading(false);
                setWithoutVolksTotalPlanLoading(false);
                
                setDataLoaded(true);
            });

        }

        if (assetIds.length && !dataLoaded) fetchData();
        else if (!allAssets.length) {
            setDataLoaded(true);
            setWithVolksTotalPlanLoading(false);
            setWithoutVolksTotalPlanLoading(false);
        }
    }, [assetIds]);

    const getBigNumberValue = (bigNumberAssetIds: string[]): number => {
        // if (!disabled) return bigNumberAssetIds.length;
        const assetIdsSet = new Set(assetIds);
        const bigNumberAssetIdsSet = new Set(bigNumberAssetIds);
        return assetIdsSet.intersection(bigNumberAssetIdsSet).size;
    }

    const getAssetIds = (bigNumberAssetIds: string[]) => {
        return bigNumberAssetIds.filter((id: string) => assetIds.includes(id));
    }

    return (
        <StatsWidget className="card">
            <StatsWidget.Header className="text-bold">{intl.formatMessage({ id: "intl-msg:monitoring.bigNumber.volksTotalHeader" })}</StatsWidget.Header>
            <StatsWidget.Body className="mt-4 flex-nowrap">
                <StatsWidgetNumber
                    className={`flex-1 min-w-0 ${withVolksTotalPlanLoading || bigTableLoading ? `animate-pulse` : ``} ${disabled || (filter !== '' && filter !== 'withVolksTotalPlan') ? `` : 'cursor-pointer'}`}
                    value={withVolksTotalPlanLoading || bigTableLoading ?
                        <div className="width-30 height-40 bg-gray-300 rounded mb-8 mx-auto"></div> :
                        <span className={disabled || (filter !== '' && filter !== 'withVolksTotalPlan') ? `text-color-light` : 'text-color-status-driving'}>{getBigNumberValue(withVolksTotalPlanAssetIds)}</span>
                    }
                    label={withVolksTotalPlanLoading || bigTableLoading ?
                        <div className="width-70 h-8 bg-gray-300 rounded mx-auto"></div> :
                        <span className={disabled || (filter !== '' && filter !== 'withVolksTotalPlan') ? `text-color-light` : ''}>{intl.formatMessage({ id: "intl-msg:monitoring.bigNumber.withVolksTotal" })}</span>
                    }
                    onClick={() => {
                        if(disabled) return;
                        if((filter !== 'withVolksTotalPlan' && filter !== '') || disabled) return;
                        if(filter !== 'withVolksTotalPlan') [setAssetIdsWithoutFilter(assets.map(asset => asset.id)), setFilter('withVolksTotalPlan'), setAssetIds(getAssetIds(withVolksTotalPlanAssetIds))];
                        else setAssetIds(assetIdsWithoutFilter), setFilter('');
                    }}
                />
                <StatsWidgetSpacer />
                <StatsWidgetNumber
                    className={`flex-1 min-w-0 ${withoutVolksTotalPlanLoading || bigTableLoading ? `animate-pulse` : ``} ${disabled || (filter !== '' && filter !== 'withoutVolksTotalPlan') ? `` : 'cursor-pointer'}`}
                    value={withoutVolksTotalPlanLoading || bigTableLoading ?
                        <div className="width-30 height-40 bg-gray-300 rounded mb-8 mx-auto"></div> :
                        <span className={disabled || (filter !== '' && filter !== 'withoutVolksTotalPlan') ? `text-color-light` : 'text-color-danger'}>{getBigNumberValue(withoutVolksTotalPlanAssetIds)}</span>
                    }
                    label={withoutVolksTotalPlanLoading || bigTableLoading ?
                        <div className="width-70 h-8 bg-gray-300 rounded mx-auto"></div> :
                        <span className={disabled || (filter !== '' && filter !== 'withoutVolksTotalPlan') ? `text-color-light` : ''}>{intl.formatMessage({ id: "intl-msg:monitoring.bigNumber.withoutVolksTotal" })}</span>
                    }
                    onClick={() => {
                        if(disabled) return;
                        if((filter !== 'withoutVolksTotalPlan' && filter !== '') || disabled) return;
                        if(filter !== 'withoutVolksTotalPlan') [setAssetIdsWithoutFilter(assets.map(asset => asset.id)), setFilter('withoutVolksTotalPlan'), setAssetIds(getAssetIds(withoutVolksTotalPlanAssetIds))];
                        else setAssetIds(assetIdsWithoutFilter), setFilter('');
                    }}
                />
            </StatsWidget.Body>
            {/* <StatsWidget.Body>
                <StatsWidgetNumber
                    className={`
                        ${getDisabledColor(
                                (assetFilter.hasVolksTotalPlanFilter === false || assetFilter.volksTotalPlan !== 'Prev') && !isRioPlanFilterDisabled(assetFilter.hasVolksTotalPlanFilter, assetFilter.volksTotalPlan),
                                ''
                            )} 
                        cursor-pointer
                        `}
                    value={bigNumberVolksTotal?.prev}
                    label="Prev"
                    onClick={() =>
                        assetFilter.hasVolksTotalPlanFilter && setAssetFilter({
                            ...assetFilter,
                            volksTotalPlan: assetFilter.volksTotalPlan === 'Prev' ? undefined : "Prev",
                        })
                    }
                />
                <StatsWidgetSpacer />
                <StatsWidgetNumber
                    className={`
                        ${getDisabledColor(
                                (assetFilter.hasVolksTotalPlanFilter === false || assetFilter.volksTotalPlan !== 'Max') && !isRioPlanFilterDisabled(assetFilter.hasVolksTotalPlanFilter, assetFilter.volksTotalPlan),
                                ''
                            )} 
                        cursor-pointer
                        `}
                    value={bigNumberVolksTotal?.max}
                    label="Max"
                    onClick={() =>
                        assetFilter.hasVolksTotalPlanFilter && setAssetFilter({
                            ...assetFilter,
                            volksTotalPlan: assetFilter.volksTotalPlan === 'Max' ? undefined : "Max",
                        })
                    }
                />
                <StatsWidgetSpacer />
                <StatsWidgetNumber
                    className={`
                        ${getDisabledColor(
                                (assetFilter.hasVolksTotalPlanFilter === false || assetFilter.volksTotalPlan !== 'Plus') && !isRioPlanFilterDisabled(assetFilter.hasVolksTotalPlanFilter, assetFilter.volksTotalPlan),
                                ''
                            )} 
                        cursor-pointer
                        `}
                    value={bigNumberVolksTotal?.plus}
                    label="Plus"
                    onClick={() =>
                        assetFilter.hasVolksTotalPlanFilter && setAssetFilter({
                            ...assetFilter,
                            volksTotalPlan: assetFilter.volksTotalPlan === 'Plus' ? undefined : "Plus",
                        })
                    }
                />
            </StatsWidget.Body> */}
        </StatsWidget>
    )
}

export default VolksTotalPlanBigNumbers;